import React from 'react';
import PropTypes from 'prop-types';
import Avatar, { DefaultAvatar } from '@adsk/alloy-react-avatar';
import { MEMBER_STATUS } from '@adsk/acs-admin-ui-components-helpers';
import { NO_AVATAR_SUFFIX } from './constants';

const MemberAvatar = ({ imageUrl, name, size, status }) => {
  let avatar = <Avatar size={size} name={name} />;

  if (status === MEMBER_STATUS.PENDING || !name?.match(/[A-Z|a-z]/i)) {
    avatar = <DefaultAvatar size={size} />;
  } else if (imageUrl && !imageUrl.endsWith(NO_AVATAR_SUFFIX)) {
    avatar = <Avatar size={size} image={imageUrl} />;
  }

  return avatar;
};

MemberAvatar.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.string,
  status: PropTypes.string,
};

MemberAvatar.defaultProps = {
  size: Avatar.SIZES.XLARGE_64,
};

export default MemberAvatar;
